<template>
  <ShopHeader />
  <ContentWrap class="main">
    <div class="content">
      <!-- 商品简介 -->
      <div class="goods-summary clearfix">
        <!-- 商品信息 -->
        <div class="goods-info pull-right">
          <h1 class="goods-title">
            {{ goodsInfo.title }}
          </h1>
          <div class="goods-price clearfix">
            <strong class="goods-current-price pull-left">
              <em class="goods-rmb">￥</em><span>{{ goodsInfo.price / 100 }}</span>
            </strong>
          </div>
          <table class="goods-meta">
            <tbody>
              <tr class="first-child">
                <td class="goods-meta-name">运费：</td>
                <td>免运费</td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
          <div class="goods-action clearfix">
            <a @click="pay" href="javascript:;" class="goods-buy-link icon-buybutton pull-left js-hover" data-target="js-popover-goods" data-position="top" data-shake="true">立即购买</a>
          </div>
          <div class="goods-payment">
            <dl class="clearfix">
              <dt>支付：</dt>
              <dd class="pull-left clearfix">
                <a href="javascript:;" class="clearfix pull-left"><span class="icon-wxpay"></span>微信支付</a>
                <!-- <a href="javascript:;" class="clearfix pull-left"><span class="icon-bankpay"></span>银行卡</a>
                <a href="javascript:;" class="clearfix pull-left"><span class="icon-alipay"></span>支付宝</a> -->
              </dd>
            </dl>
          </div>
        </div>
        <!-- 商品图片 -->
        <div class="goods-image pull-left">
          <img :src="goodsInfo.img" alt="【2021暑期托管营 】趣味阅读营+单词探索营+作业答疑营（XGS） 商品图0" />
        </div>
      </div>
      <!-- 商品详情 -->
      <div class="goods-detail js-goods-detail">
        <h2 class="title">商品详情</h2>
        <div class="rich-text">
          <p>
            <img v-for="(item, index) in goodsInfo.info" :key="index" data-origin-width="750" data-origin-height="1090" :src="item" />
          </p>
        </div>
      </div>
    </div>
  </ContentWrap>
  <PayWx ref="payWx" />
</template>

<script>
import goodList from './goodList'
import ShopHeader from '../Layout/shopHeader.vue'
import ContentWrap from '../Layout/contentWrap.vue'
import PayWx from '../components/payWx.vue'
export default {
  components: {
    ShopHeader,
    ContentWrap,
    PayWx
  },
  data() {
    return {
      goodList
    }
  },
  computed: {
    goodsInfo() {
      return this.goodList.find(item => item.id === this.$route.query.goodsId)
    }
  },
  methods: {
    pay() {
      this.$store.dispatch('root/checkLogin').then(isLogin => {
        if (isLogin) {
          this.$refs.payWx.open(this.goodsInfo.id)
        }
      })
    }
  }
}
</script>

<style scoped>
.main .content {
  text-align: left;
  width: 740px;
  padding: 30px;
  float: left;
  background-color: #fff;
}

@media screen and (min-width: 1160px) {
  .main .content {
    width: 860px;
    padding: 40px;
  }
}

.main .content .goods-summary {
  margin-bottom: 30px;
}

.main .content .goods-image {
  width: 400px;
}
.main .content .goods-image img {
  width: 100%;
}

.main .content .goods-info {
  width: 310px;
  margin-left: 30px;
}

@media screen and (min-width: 1160px) {
  .main .content .goods-info {
    width: 420px;
    margin-left: 40px;
  }
}

.main .content .goods-title {
  color: #333;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  margin: 15px 0;
}

.main .content .goods-price {
  text-align: left;
  margin: 25px 0;
}

.main .content .goods-current-price {
  color: #f60;
  font-size: 30px;
  margin-right: 10px;
}

.main .content .goods-activity {
  background-color: #e00;
  color: #fff;
  font-size: 14px;
  padding: 3px;
  vertical-align: middle;
  margin-top: -2px;
  display: inline-block;
  border-radius: 2px;
}

.main .content .goods-rmb {
  font-size: 24px;
}

.main .content .goods-origin-price {
  font-size: 12px;
  color: #999;
  margin-top: 14px;
}

.main .content .goods-origin-old-price {
  margin-right: 5px;
}

.main .content .goods-meta {
  width: 100%;
  font-size: 12px;
  background-color: #f8f8f8;
  padding: 20px;
  color: #333;
  margin-bottom: 35px;
}

.main .content .goods-meta td {
  padding-bottom: 15px;
  word-break: break-all;
}

.main .content .goods-meta .last-child td {
  padding-bottom: 20px;
}

.main .content .goods-meta .first-child td {
  padding-top: 20px;
}

.main .content .goods-meta-name {
  color: #999;
  width: 80px;
  padding-left: 20px;
}

.main .content .goods-action {
  margin-bottom: 30px;
}

.main .content .goods-buy-link {
  text-indent: -999999px;
}

.main .content .goods-share-link {
  margin-top: 10px;
  margin-left: 20px;
}

.main .content .goods-payment {
  font-size: 12px;
}

.main .content .goods-payment dt {
  float: left;
  color: #999;
  margin-right: 20px;
  line-height: 16px;
}

.main .content .goods-payment dd {
  display: inline-block;
}

.main .content .goods-payment dd a {
  color: #666;
  margin-right: 20px;
  line-height: 16px;
  cursor: default;
}

.main .content .goods-payment dd a span {
  margin: 0 5px 0 0;
  float: left;
}

.main .content .goods-detail {
  margin-bottom: 50px;
}

.main .content .goods-detail .title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  background-color: #f8f8f8;
  border-top: 1px solid #e6e6e6;
  padding: 12px 15px;
  margin-bottom: 25px;
}

.main .content .detail-links {
  font-size: 12px;
  position: relative;
  z-index: -1;
}
.pull-right {
  float: right;
}

.clearfix {
  *zoom: 1;
}

.clearfix:after {
  content: '';
  display: table;
  clear: both;
}
icon-wxv {
  display: inline-block;
  height: 16px;
  width: 16px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -515px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-wxv {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -515px;
    background-size: 180px auto;
  }
}

.icon-weixin {
  display: inline-block;
  height: 48px;
  width: 55px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -428px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-weixin {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -428px;
    background-size: 180px auto;
  }
}

.icon-wxpay-new {
  display: inline-block;
  height: 23px;
  width: 27px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -492px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-wxpay-new {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -492px;
    background-size: 180px auto;
  }
}

.icon-alipay-new {
  display: inline-block;
  height: 26px;
  width: 24px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -32px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-alipay-new {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -32px;
    background-size: 180px auto;
  }
}

.icon-buybutton {
  display: inline-block;
  height: 50px;
  width: 180px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -74px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-buybutton {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -74px;
    background-size: 180px auto;
  }
}

.icon-wxpay {
  display: inline-block;
  height: 16px;
  width: 16px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -476px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-wxpay {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -476px;
    background-size: 180px auto;
  }
}

.icon-bankpay {
  display: inline-block;
  height: 16px;
  width: 16px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -58px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-bankpay {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -58px;
    background-size: 180px auto;
  }
}

.icon-alipay {
  display: inline-block;
  height: 16px;
  width: 16px;
  background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-s36da3721fe.png');
  background-position: 0 -16px;
  background-repeat: no-repeat;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .icon-alipay {
    background-image: url('https://b.yzcdn.cn/v2/shop/images/icons-retina-s2612b25cd2.png');
    background-position: 0 -16px;
    background-size: 180px auto;
  }
}
</style>
